import { useDecision } from '@optimizely/react-sdk'
import { useMemo } from 'react'

import { type DashboardExperienceApiVersion, getDashboardExperienceCacheKey } from '../configs'
import {
  DASHBOARD_EXPERIENCE_V2_FEATURE_FLAG_KEY,
  getDashboardExperienceTelemetryContext,
} from './dashboardExperienceTelemetry'

export { DASHBOARD_EXPERIENCE_V2_FEATURE_FLAG_KEY }

export const getDashboardExperienceApiVersionFromDecision = (
  isV2Enabled: boolean,
): DashboardExperienceApiVersion => (isV2Enabled ? 'v2' : 'v1')

export const useDashboardExperienceApiConfig = () => {
  const [decision, isDecisionReady, hasDecisionTimedOut] = useDecision(
    DASHBOARD_EXPERIENCE_V2_FEATURE_FLAG_KEY,
  )
  const apiVersion = getDashboardExperienceApiVersionFromDecision(decision.enabled === true)
  const telemetryContext = useMemo(
    () =>
      getDashboardExperienceTelemetryContext({
        apiVersion,
        decision,
        hasDecisionTimedOut,
        isDecisionReady,
      }),
    [apiVersion, decision, hasDecisionTimedOut, isDecisionReady],
  )

  return {
    apiVersion,
    cacheKey: getDashboardExperienceCacheKey(apiVersion),
    isReady: isDecisionReady || hasDecisionTimedOut,
    telemetryContext,
  }
}
